<template>
    <div
        class="banner"
        :style="{
            'background-color': `${backgroundColor}`,
            'background-image': `url(${backgroundImage})`
        }"
    >
        <slot>
            <div class="banner__title" v-html="title"></div>
            <hr v-if="displayBannerLine" class="banner__line">
            <div class="banner__tagline" v-html="tagline"></div>
        </slot>
    </div>
</template>

<script>
export default {
    props: {
        displayBannerLine: {
            default: true,
            required: false,
            type: Boolean
        },
        title: {
            required: false,
            type: String
        },
        tagline: {
            required: false,
            type: String
        },
        backgroundColor: {
            required: false,
            type: String
        },
        backgroundImage: {
            required: false,
            type: String
        }
    }

}

</script>

<style lang="postcss" scoped>
@import 'theme';
.banner {
    align-items: center;
    background-blend-mode: multiply;
    background-size: cover;
    color: #fff;
    display: flex;
    flex-direction: column;
    height: 96px;
    justify-content: center;
    margin: 0 0 16px -16px;
    padding: 13px 12px 10px 13px;
    width: 100vw;

    @media (--mq-large-min) {
        height: 160px;
        margin: 24px 0 24px 0;
        width: 100%;
    }

    & .banner__title {
        font-size: 20px;
        font-weight: 100;
        text-align: center;

        & >>> .registered-trademark-icon {
            font-size: 12px;
            @media (--mq-large-min) {
                font-size: 17px;
            }
        }

        @media (--mq-large-min) {
            font-size: 32px;
        }
    }

    & .banner__line {
        width: 120px;
        margin: 8px 0 8px 0;
        @media (--mq-large-min) {
            margin: 16px 0 16px 0;
        }
    }

    & .banner__tagline {
        font-size: 12px;
        font-weight: 100;
        padding: 0 12px 10px 12px;
        text-align: center;

        @media (--mq-large-min) {
            font-size: 16px;
        }
    }
}

</style>
